<template>
     <section class="section-two-full-blocks-2">
            <div class="container">
                <div class="row">
                    <div class="col-md-1">
                        <div class="text-wrap">
                            <div class="show-above section-left mb4">
                                <p></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-10">
                        <div class="text-wrap mt4">
                            <div class="center-align mb4 faq-center" >
                              <p class="hr-title mb4"><hr><span>FAQ's</span></p>
                                <h1 class="mb2"><b>Have your say on <br>the Route Options</b></h1>
                                <!-- <p class="mb4"> A detailed map of each route corridor option is available to download</p> -->
                                <a href="/site/haveYourSay" class="cta cta-white">Have Your Say</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-1">
                        <div class="text-wrap">
                            <div class="show-above section-left mb4">
                                <p></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
  name: 'TwoColumnJustFeedbackFooter',
  data () {
    return {
    }
  },
  mounted () {
  
    
  },
  methods: {
   
  }
}
</script>
<style lang="scss">
.section-two-full-blocks-2{
    position: relative;
    padding: 4rem 0;
    margin: 0 auto;
    color: white;
    background:#473192;

    span {
        color: white;
    }
    p {
        color: white;
    }
    h1 {
        color: white;
    }
    // img.sideImage{
    //   position: absolute;
    //   left: 0;
    //   bottom: 0;
    //   width: 66%;
    //   pointer-events: none;
    // }
      &::before{
          content: "";
          display: block;
          width: 50%;
          height: 100%;
          background-position: 50%;
          // background: url('https://via.placeholder.com/1024x768') no-repeat;
          background-position: 100%;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          background:#473192 url('../../assets/images/Belfast/PathMaskPurple.png') no-repeat;
      }
      
   
    
}

div.faq-center{
    align-content: center;
}
</style>
